import React from 'react';
import './documentosAnexos.scss';

//Componentes
import FileUpload from '../../../../components/fileUpload';
import CheckObligation from '../../components/checkObligation';
import Table from '../../../../components/table';
import Form from '../../../../components/form';
import { uploadDocumento } from '../../../../store/associadoPJReducer/actions';

class DocumentosAnexos extends React.Component {
  constructor(props) {
    super(props)
    this.props.updateState({ currentValidation: this.handleValidations });
    this.setDocumentosAnexos = (id, changes) => {
      this.props.updateState({
        documentosAnexos: {
          ...this.props.documentosAnexos,
          [id]: {
            ...this.props.documentosAnexos[id],
            ...changes
          }
        },
      });
    };
    this.changeDocumentosAnexos = this.changeDocumentosAnexos.bind(this);
    this.documentosDeleteFile = this.documentosDeleteFile.bind(this);
  }

  componentWillMount() {
    this.formFields = [];
  }

  CheckObligationAssociado = (props) => <CheckObligation {...props} currentStep={this.props.currentStep} />;

  documentosDeleteFile({ id }) {
    this.setDocumentosAnexos(id, {
      value: "",
      base64: "",
      fileType: null,
      IdDocumentoArquivo: '',
      asyncLoading: false,
      file: null,
      active: false,
      documents: []
    });
  }

  changeDocumentosAnexos(element) {
    const { id, base64, file } = element;

    if (!base64) {
      this.documentosDeleteFile(element);
      return;
    }

    //1mb = 1048576
    console.log(file.size);
    if (file.size > 3*1048576) {
      this.setDocumentosAnexos(id, { errorMessage: 'Tamanho do arquivo maior que o limite 3MB.' });
      return;
    }

    if (element.fileType === "jpeg") {
      element.fileType = 1;
    } else if (element.fileType === "png") {
      element.fileType = 2;
    } else {
      element.fileType = 3;
    }

    const payload = {
      IdTipoArquivo: element.fileType,
      IdTipoDocumento: element.documentType,
      IdGrupoDocumento: element.idGrupoDocumento,
      IdTipoDocumentoImagem: element.imageType,
      Arquivo: element.base64,
      DescricaoDocumento: element.id
    };

    this.setDocumentosAnexos(id, { asyncLoading: true });

    uploadDocumento(payload)
      .then((data) => {
        element.IdDocumentoArquivo = data.IdDocumentoArquivo;
        element.base64 = 'uploaded';
        this.setDocumentosAnexos(id, {
          ...element,
          errorMessage: '',
          documents:
            element.documents.length === 0 && !element.IdDocumentoArquivo ?
              element.documents : this.props.documentosAnexos[id].documents.concat([element])
        })
      })
      .catch((errorMessage) => this.setDocumentosAnexos(id, { errorMessage }))
      .finally(() => this.setDocumentosAnexos(id, { asyncLoading: false }));
  }

  render() {
    const {
      documentos_documentoIdentificacaoFrente,
      documentos_documentoIdentificacaoVerso,
      documentos_comprovanteResidenciaComprovante,
    } = this.props.documentosAnexos;

    const {
      listTypeArquivo
    } = this.props.documentosAnexosReducer;

    const {
      dadosIniciais_tipoDocumento,
    } = this.props;

    const documentos_formAssociadoFlag = true;

    const CheckObligationAssociado = this.CheckObligationAssociado;
  
    return (
      <Form name="documentosAnexosForm">
        <CheckObligationAssociado field="documentos_documentoIdentificacaoFrente">
          {(validacoes) =>
            <FileUpload
              name="documentos_documentoIdentificacaoFrente"
              id="documentos_documentoIdentificacaoFrente"
              onChange={this.changeDocumentosAnexos}
              textFile="Frente do documento de identificação com foto e CPF."
              subText="RG, CNH ou documento de orgão de classe dentro do prazo de validade."
              listTypeArquivo={listTypeArquivo}
              documentType={15}
              imageType={1}
              idGrupoDocumento={7}
              required={validacoes.obrigatorio}
              disable={documentos_documentoIdentificacaoFrente.documents.length > 0}
              onlyOneArchive={true}
              {...documentos_documentoIdentificacaoFrente}
              returnObject={this.createRefFields}
            />}
        </CheckObligationAssociado>
        <Table
          list={documentos_documentoIdentificacaoFrente.documents}
          onClick={this.documentosDeleteFile}
        />

        <CheckObligationAssociado field="documentos_documentoIdentificacaoVerso" fieldConditional={{ dadosIniciais_tipoDocumento }}>
          {(validacoes) =>
            <FileUpload
              name="documentos_documentoIdentificacaoVerso"
              id="documentos_documentoIdentificacaoVerso"
              onChange={this.changeDocumentosAnexos}
              textFile="Verso do documento de identificação e CPF."
              subText="RG, CNH ou documento de orgão de classe dentro do prazo de validade."
              listTypeArquivo={listTypeArquivo}
              {...documentos_documentoIdentificacaoVerso}
              documentType={15}
              imageType={2}
              idGrupoDocumento={7}
              disable={documentos_documentoIdentificacaoVerso.documents.length > 0}
              onlyOneArchive={true}
              required={validacoes.obrigatorio}
              returnObject={this.createRefFields}
            />}
        </CheckObligationAssociado>
        <Table
          list={documentos_documentoIdentificacaoVerso.documents}
          onClick={this.documentosDeleteFile}
        />

        <CheckObligationAssociado field="documentos_comprovanteResidenciaComprovante" fieldConditional={{ documentos_formAssociadoFlag }}>
          {(validacoes) =>
            <FileUpload
              name="documentos_comprovanteResidenciaComprovante"
              id="documentos_comprovanteResidenciaComprovante"
              onChange={this.changeDocumentosAnexos}
              textFile="Comprovante de endereço em nome do cliente"
              subText="Conta de consumo como água, luz, telefone fixo ou gás, emitido nos últimos 90 dias."
              listTypeArquivo={listTypeArquivo}
              {...documentos_comprovanteResidenciaComprovante}
              documentType={3}
              imageType={4}
              idGrupoDocumento={7}
              required={validacoes.obrigatorio}
              returnObject={this.createRefFields}
            />}
        </CheckObligationAssociado>
        <Table
          list={documentos_comprovanteResidenciaComprovante.documents}
          onClick={this.documentosDeleteFile}
        />
      </Form>
    );
  }

  createRefFields = (self) => {
    this.formFields[self.props.name] = self
  }

  handleValidations = async () => {
    const keys = Object.keys(this.formFields);
    if (keys.length === 0) return true;

    for (const key of keys)
      if (!await this.formFields[key].validate(this.formFields[key].input)) return false;

    return true;
  };
}

export default DocumentosAnexos;

